import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store, createSelector } from '@ngrx/store';
import { concatMap, filter, map } from 'rxjs';

import { BetslipType } from '../../../core/betslip-type';
import { BaseBetslipGroupPick } from '../../../core/picks/betslip-group-pick';
import { betslipTypesBaseSelector } from '../../types/base/selectors';
import BetslipPickActions from '../actions';
import { betslipPicksListSelector } from '../selectors';

export const betslipPicksAndBaseTypeSelector = createSelector(betslipTypesBaseSelector, betslipPicksListSelector, (baseTypeState, pickList) => ({
    currentSelectedType: baseTypeState.currentSelectedType,
    pickList,
}));
@Injectable()
export default class GroupsInternalPicksUpdateEffects {
    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}

    /**
     * When an event update action is dispatched
     * Traverse all groups in the pick list
     * and update individual legs(picks) relevant to the updated event
     */
    handleEventUpdatedActionEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPickActions.updateV1Picks, BetslipPickActions.updateV2Picks, BetslipPickActions.updateGroupPickLegs),
            concatLatestFrom(() => this.store.select(betslipPicksAndBaseTypeSelector)),
            filter(([_, betslipState]) => betslipState.currentSelectedType !== BetslipType.EditBet),
            map(([action, betslipState]) => {
                const groupsContainingPick = betslipState.pickList.filter(
                    (pick) => BaseBetslipGroupPick.isPick(pick) && action.pickUpdates.some((pickUpdate) => pick.hasPick(pickUpdate.pick.id)),
                );

                return [action, betslipState, groupsContainingPick] as [typeof action, typeof betslipState, BaseBetslipGroupPick[]];
            }),
            filter(([_, __, groupsContainingPick]) => !!groupsContainingPick.length),
            concatMap(([action, _, groupsContainingPick]) => {
                return groupsContainingPick
                    .map((p) => {
                        const updatedPicks = p.getLegs().map((leg) => {
                            const update = action.pickUpdates.find((pickUpdate) => pickUpdate.pick.id.toString() === leg.id.toString());

                            return update ? update.pick : leg;
                        });

                        return p.updatePicks(updatedPicks);
                    })
                    .map((pick) =>
                        BetslipPickActions.replacePick({
                            newPick: pick,
                            pickId: pick.id,
                            skipPickSubscriptionCleanup: true,
                        }),
                    );
            }),
        );
    });
}
